module.exports = __webpack_public_path__ + "d7d4027504452f62d2ef4297f7828627.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/logout.svg
// module id = TYkI
// module chunks = 0